<template>
  <div class="myCollContent">
    <div class="top_set">
      <a href="/user?index=0">通行证首页</a>
      <span> >我的收藏 </span>
    </div>
    <div class="leftNav">
      <p :class="currentSet==1?'activeSet':'noavtiveSet'" @click="changeSet(1)">
        <span v-show="currentSet==1" style="height: 60px;"><img style="margin-top: 16px;width: 25px;" :src="zgw2" alt=""><span>彭祖世家网</span></span>
        <span v-show="currentSet==2" style="height: 60px;"><img style="margin-top: 16px;width: 25px;" :src="zgw1" alt=""><span>彭祖世家网</span></span>
      </p>
      <p :class="currentSet==2?'activeSet':'noavtiveSet'" @click="changeSet(2)">
        <span v-show="currentSet==2" style="padding-top: 4px;height: 56px;"><img style="margin-top: 19px;" :src="py2" alt=""><span>谱阅</span></span>
        <span v-show="currentSet==1" style="padding-top: 4px;height: 56px;"><img style="margin-top: 19px;" :src="py1" alt=""><span>谱阅</span></span>
      </p>
    </div>
    <collect1 v-show="currentSet==1" />
    <collect2 v-show="currentSet==2" />
  </div>
</template>

<script>
// import pagination from '@/components/userCenter/pagination.vue'
import collect1 from '@/components/passcardNav/collect1.vue'
import collect2 from '@/components/passcardNav/collect2.vue'
export default {
  name: 'Index',
  components: {
    collect1, collect2
  },
  inject: ['reload'],
  data() {
    return {
      zgw1: require('@/static/pengdps.png'),
      zgw2: require('@/static/pengdps.png'),
      py1: require('@/static/py1.png'),
      py2: require('@/static/py2.png'),
      currentSet: 1,
      value1: '全部分类', // ////选择的分类
      value2: '' // ///搜索值
    }
  },
  mounted() {

  },
  methods: {
    changeSet(index) {
      this.currentSet = index
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .cellSty{
    .cell{
      padding-left: 20px!important;
    }
  }
  .phoneBox{
    display: none;
  }
  .myCollContent{
    overflow: hidden;
    min-height: 100vh;
    .top_set{
      height: 80px;
      line-height: 80px;
      text-align: left;
      font-size: 14px;
      a{
        color: #999999;
      }
      span{
        color: #666666;
      }
    }
    .leftNav{
      background-color: #fff;
      width: 260px;
      display: inline-block;
      vertical-align: top;
      margin-right: 40px;
      font-size: 16px;
      overflow: hidden;
      svg{
        margin-right: 10px;
        font-size: 20px;
      }
      span{
        display: inline-block;
        vertical-align: top;
      }
      .svg1{
        font-size: 25px;
      }
      .noavtiveSet{
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        background-color: #fff;
        padding-left: 30px;
        color: #333;
        img{
          margin-right: 15px;
        }
      }
      .activeSet{
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        background-color: #FAFCFF;
        padding-left: 30px;
        color: #E0466E;
        img{
          margin-right: 15px;
        }
      }
    }
    .right_box{
      width: 840px;
      display: inline-block;
      vertical-align: top;
      background-color: #fff;
      padding: 0 30px;
      overflow: hidden;
      .tips{
        display: inline-block;
        padding-left: 7px;
        border-left: 3px solid #E0466E;
        height: 17px;
        line-height: 17px;
        margin-top: 30px;
        font-size: 18px;
      }
    }
  }
  .toptitle {
    line-height: 40px;
    height: 40px;
    border-bottom: 1px solid #e5e5e5;
    span {
      display: inline-block;
      height: 39px;
      font-size: 14px;
      color: #4e4e4e;
      width: 72px;
      border-bottom: 2px solid #ed4040;
    }
  }
  .searchs{
    width: 217px;
    display: inline-block;
    margin-left: 12px;
    vertical-align: middle;
  }
  .collect_search{
    display: inline-block;
    position: absolute;
    width: 30px;
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    color: #b3b3b3;
    right: 0;
    cursor: pointer;
  }
  .searchBox{
    position: relative;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
  }
  .topBox{
    padding: 18px 30px;
    padding-left: 10px;
    background-color: #F1F7FF;
    margin-bottom: 15px;
    .btnType1{
      padding: 5px 20px;
      border: 1px solid #E0466E;
      border-radius: 3px;
      color: #ffffff;
      font-size: 14px;
      background-color: #E0466E;
      margin-left: 15px;
      cursor: pointer;
  }
    .btnType1_no{
      padding: 5px 20px;
      border: 1px solid #E5E5E5;
      border-radius: 3px;
      color: #333333;
      font-size: 14px;
      background-color: #fff;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  .selects{
    position:relative;
  }
  .quxiao{
    background-color: #ed4040!important;
    border: none!important;
  }
  .Btn{
    color: #5aa0fd;
    font-size: 14px;
    cursor: pointer;
  }
  ///收藏的单个删除功能添加
  .cancelBtn{
    color: #e0466e;
    font-size: 14px;
    margin-left: 10px;
    cursor: pointer;
  }
  .templateName{
    width: 38px;
    height: 22px;
    display: inline-block;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    line-height: 22px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .content_name{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    max-width: 330px;
    overflow: hidden;
  }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .myCollContent{
      padding: 0 10px;
    }
    .selects{
      width: 30vw;
    }
    .searchBox{
      width: 50vw;
    }
    .searchs{
      width: 45vw;
    }
    .PcshowBox{
      display: none;
    }
    .phoneBox{
      display: block;
      padding-top: 20px;
      .phoneList{
        position: relative;
        margin: 20px 0;
        .phoneNames{
          width: calc( 100vw -  100px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow:ellipsis
        }
        .cancelBtn{
          position: absolute;
          top: 0;
          right: 0;
        }
      }

    }

  }
</style>
<style rel="stylesheet/scss" lang="scss">
  .myCollContent{
    .el-table .cell{
      padding-left: 30px!important;
    }
  }
</style>
